import React from "react";
import { usePage, Link } from "@inertiajs/react";
import { Button } from "./ui/button";

interface User {
  id: number;
  email_address: string;
}

interface PageProps {
  current_user?: User;
  authenticated: boolean;
}

interface Props {
  children: React.ReactNode;
}

export default function Layout({ children }: Props) {
  const { current_user, authenticated } = usePage<PageProps>().props;

  const handleSignOut = () => {
    if (confirm("Are you sure you want to sign out?")) {
      // Using form submission for DELETE request
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/session";

      const methodInput = document.createElement("input");
      methodInput.type = "hidden";
      methodInput.name = "_method";
      methodInput.value = "DELETE";

      const tokenInput = document.createElement("input");
      tokenInput.type = "hidden";
      tokenInput.name = "authenticity_token";
      tokenInput.value =
        document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute("content") || "";

      form.appendChild(methodInput);
      form.appendChild(tokenInput);
      document.body.appendChild(form);
      form.submit();
    }
  };

  return (
    <div className="flex flex-col h-screen max-h-screen bg-background">
      <nav className="sticky top-0 z-50 flex-shrink-0 border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link
                href="/"
                className="text-xl font-bold text-green-700 text-foreground"
              >
                ⛳ ⛳ golf golf
              </Link>
            </div>

            <div className="flex items-center space-x-4">
              {authenticated && current_user ? (
                <>
                  <span className="text-muted-foreground">
                    Welcome, {current_user.email_address}
                  </span>
                  <Button asChild>
                    <Link href="/videos/new">Upload New Video</Link>
                  </Button>
                  <Button
                    onClick={handleSignOut}
                    variant="destructive"
                    size="sm"
                  >
                    Sign Out
                  </Button>
                </>
              ) : (
                <Button asChild size="sm">
                  <Link href="/session/new">Sign In</Link>
                </Button>
              )}
            </div>
          </div>
        </div>
      </nav>

      <main className="overflow-hidden flex-1">{children}</main>
    </div>
  );
}
